import { Injectable } from '@angular/core';
import { Router } from "@angular/router";
import firebase from 'firebase/compat/app'

import { Auth, authState, UserCredential, getAuth, onAuthStateChanged, signInWithEmailAndPassword, signInWithPopup, createUserWithEmailAndPassword, signOut, sendPasswordResetEmail, confirmPasswordReset, sendEmailVerification, updateEmail, updatePassword, updateProfile, User } from '@angular/fire/auth';
import { doc, docData, collection, collectionData, Firestore, query, orderBy, where, limit, addDoc, updateDoc, deleteDoc, setDoc, deleteField, getDocs, collectionGroup, writeBatch, startAfter, getDocsFromServer, startAt, endAt, getDoc } from '@angular/fire/firestore';

import { User as CoddyUser } from '../classes/index';

import { Observable, of, BehaviorSubject } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class AuthService {

  public userId;
  public user: Observable<User>;
  public userDetails: firebase.User = null;

  public userDoc;
  public userInfo: CoddyUser;

	private _credentials: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	public readonly credentials$: Observable<any> = this._credentials.asObservable();

  constructor(private _firebaseAuth: Auth, private router: Router, private firestore: Firestore) {
    this.user = authState(this._firebaseAuth);

		this.userDoc = this.user
    .pipe(switchMap(user => {
      console.log('Logged in user detected:'+JSON.stringify(user));
			this._credentials.next(null);
			if (user) {
				this.userId = user.uid;
				return docData(doc(this.firestore, `users/${user.uid}`));
			} else {
				this.userId = null;
				return of(null);
			}
    }));
		this.userDoc.subscribe(user => {
			this.userInfo = user;
      this._credentials.next(user);
		});
	
    /*this.user.subscribe(
      (user) => {
        if (user) {
          this.userId = user.uid;
          this.userDetails = user;
          console.log('Authenticated user:'+JSON.stringify(this.userDetails));
          this.listenToUser();
          this.updateUserData(user);
        }
        else {
          this.userDetails = null;
        }
      }
    );*/
  }

  /*listenToUser(){
    if(this.userDoc){
      this.userDoc.unsubscribe();
    }
    console.log('listenToUser:'+this.userId);
    if(this.userId){
      this.userDoc = this._firestore.doc<User>(`users/${this.userId}`).valueChanges();
      this.userDoc.subscribe(userData => {
        this.userInfo = userData;
        console.log('got coddy user:'+this.userInfo);
      });
    }
  }*/
  getUser(){
    return docData(doc(this.firestore, `users/${this.userId}`));
  }
  async register(email, password, fullName, company) {
    return createUserWithEmailAndPassword(this._firebaseAuth, email, password)
    .then(async (afUser: UserCredential) => {
      //await this.updateUserData(afUser.user);
      updateProfile(afUser.user, {displayName: fullName});
      //this._firestore.firestore.collection("users").doc(afUser.user.uid).set({ company: company });
      
      this.sendEmailVerification();
    });
  }

  /*updateUserData(afUser){
    this._firestore.firestore.collection("users").doc(afUser.uid).set(
      {
        uid: afUser.uid,
        displayName: afUser.displayName || '',
        email: afUser.email || '',
        photoURL: afUser.photoURL || ''
      }, { merge: true }
    );
  }*/

  sendEmailVerification() {
    authState(this._firebaseAuth).subscribe(user => {
      console.log('Send verification email to user:'+JSON.stringify(user));
      sendEmailVerification(user)
      .then(() => {
        console.log('email sent');
      })
    });
  }

	updateUserData(favoriteGames) {
		return updateDoc(doc(this.firestore, `users/${this.userId}`), {favoriteGames: favoriteGames});
	}

  requestPass(email) {
    return sendPasswordResetEmail(this._firebaseAuth, email);
  }

  confirmPasswordReset(code, newPassword) { // param: oobCode=<code>
    return confirmPasswordReset(this._firebaseAuth, code, newPassword);
  }

  /*verifyPasswordResetCode(code){
    return this._firebaseAuth.auth.verifyPasswordResetCode(code);
  }*/

  signInWithEmail(email, password) {
    return signInWithEmailAndPassword(this._firebaseAuth, email, password);
  }
  
  signInWithTwitter() {
    return signInWithPopup(this._firebaseAuth,
      new firebase.auth.TwitterAuthProvider()
    )
  }

  signInWithFacebook() {
    return signInWithPopup(this._firebaseAuth,
      new firebase.auth.FacebookAuthProvider()
    )
  }

  signInWithGoogle() {
    return signInWithPopup(this._firebaseAuth,
      new firebase.auth.GoogleAuthProvider()
    )
  }

  isLoggedIn() {
    if (this.userDetails == null) {
      return false;
    } else {
      return true;
    }
  }
  logout() {
    this._firebaseAuth.signOut()
      .then((res) => this.router.navigate(['/auth/login']));
  }
}